import { isMarketingWebsiteHost } from '@core/boot/marketing-host-redirect';

export function isMarketingWebsiteRootHost(hostname: string): boolean {
  const normalized = hostname.trim().toLowerCase();
  // Sin hostname (SSG): tratar como raíz marketing.
  return !normalized || isMarketingWebsiteHost(normalized);
}

/** RouterLink commands for website routes (root on milinco.com, `/website` prefix in dev). */
export function marketingWebsiteRouterCommandsForHost(
  hostname: string | undefined,
  ...segments: string[]
): string[] {
  const onRoot = isMarketingWebsiteRootHost(hostname ?? '');
  const parts = segments.flatMap((segment) => segment.split('/').filter(Boolean));

  if (onRoot) {
    return parts.length ? ['/', ...parts] : ['/'];
  }

  return parts.length ? ['/website', ...parts] : ['/website'];
}

export function marketingWebsiteRouterCommands(...segments: string[]): string[] {
  return marketingWebsiteRouterCommandsForHost(globalThis.location?.hostname, ...segments);
}
